export default "2ab7a0f1f1e9aea2.svg"